import api from './api.js'

// 消息列表
export function getStationMessageLogList(params){
    return api.get('/resource-message/api/v1/stationMessage/log/query',params);
}

//标记已读
export function updateStationMessageStatusById(param) {
    return api.get('/resource-message/api/v1/stationMessage/log/updateStationMessageStatusById',param);
}

//全部已读
export function updateStationMessageStatusAll() {
    return api.get('/resource-message/api/v1/stationMessage/log/updateStationMessageStatusAll');
}

//删除
export function deleteStationMessageLog(params) {
    return api.get('/resource-message/api/v1/stationMessage/log/delete',params);
}

//消息未读条数
export function unreadNum() {
    return api.get('/resource-message/api/v1/stationMessage/log/unreadNum');
}




// WEBPACK FOOTER //
// ./src/utils/stationMessageLog.js